import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Kullanıcıdan gelen Firebase Konfigürasyonu
const firebaseConfig = {
  apiKey: "AIzaSyAvII0R8SIk0H1CKvC9EoL6inc1Ffve14k",
  authDomain: "kareyapi-web.firebaseapp.com",
  projectId: "kareyapi-web",
  storageBucket: "kareyapi-web.firebasestorage.app",
  messagingSenderId: "316341506430",
  appId: "1:316341506430:web:e5cf36de08b78c7d81232f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
